import { Units } from '@/pages/ValuationsV2/enums';

export const SORT_TYPES = {
  NAME: { label: 'NAME', filter: 'display_name' },
  NPV: { label: 'NPV', filter: 'npv' },
  RESERVES: { label: 'RESERVES', filter: 'remaining_reserves' },
} as const;

export const SORT_MENU_ITEMS = [
  { label: 'Name', value: SORT_TYPES.NAME },
  { label: 'NPV', value: SORT_TYPES.NPV },
  { label: 'Reserves', value: SORT_TYPES.RESERVES },
] as const;

const METRIC_CONFIGS = {
  NPV: {
    label: 'NPV',
    unit: `(${Units.UsDollarMillions})`,
    field: 'formattedNpv' as const,
  },
  RESERVES: {
    label: 'RES.',
    unit: `(${Units.MillionBoe})`,
    field: 'formattedRemainingReserves' as const,
  },
} as const;

export const SORT_FILTER_TO_METRIC = {
  npv: METRIC_CONFIGS.NPV,
  remaining_reserves: METRIC_CONFIGS.RESERVES,
} as const;

export const EMPTY_ASSETS_MESSAGE = '0 assets match your selected filters';
